// extracted by mini-css-extract-plugin
export default {"address":"style_address__xzf9J","compact":"style_compact__JKy2i"};